import CONSTS_CONFIG from "@/baseConfig/consts";
/**
 * 去空格函数
 * @param {*} str
 */
export function trim(str) {
  if (!str) {
    return "";
  }
  if (str === "null" || str === "undefined") {
    return "";
  }
  return str.replace(/(^\s*)|(\s*$)/g, "");
}

export function trimAll(str) {
  if (!str) {
    return "";
  }
  if (str === "null" || str === "undefined") {
    return "";
  }
  return str.replace(/\s/g, "");
}

/**
 * 合并JSON数据
 * @param {*} des 目标数据
 * @param {*} src 来源数据
 * @param {*} override  是否覆盖相同KEY
 * @returns
 */
export function mergeJson(des, src, override) {
  if (src instanceof Array) {
    for (var i = 0, len = src.length; i < len; i++)
      mergeJson(des, src[i], override);
  }
  for (var i in src) {
    if (override || !(i in des)) {
      des[i] = src[i];
    }
  }
  return des;
}

export function toPage(self, query) {
  self.$router.push(query);
}

export function isPwa() {
  return (
    window.navigator.standalone ||
    window.matchMedia("(display-mode: standalone)").matches
  );
}

export function createAutoLink(href) {
  let link = document.createElement("a");
  link.setAttribute("href", href);
  link.setAttribute("target", "_blank");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
export function isEmpty(obj) {
  if (typeof obj == "undefined" || obj == null || obj == "") {
    return true;
  } else {
    return false;
  }
}

export function deepClone(target) {
  // 定义一个变量
  let result;
  // 如果当前需要深拷贝的是一个对象的话
  if (typeof target === "object") {
    // 如果是一个数组的话
    if (Array.isArray(target)) {
      result = []; // 将result赋值为一个数组，并且执行遍历
      for (let i in target) {
        // 递归克隆数组中的每一项
        result.push(deepClone(target[i]));
      }
      // 判断如果当前的值是null的话；直接赋值为null
    } else if (target === null) {
      result = null;
      // 判断如果当前的值是一个RegExp对象的话，直接赋值
    } else if (target.constructor === RegExp) {
      result = target;
    } else {
      // 否则是普通对象，直接for in循环，递归赋值对象的所有值
      result = {};
      for (let i in target) {
        result[i] = deepClone(target[i]);
      }
    }
    // 如果不是对象的话，就是基本数据类型，那么直接赋值
  } else {
    result = target;
  }
  // 返回最终结果
  return result;
}


// LiveChat
export function loadLiveChat(country, callback) {
  if (window.nodeTawk) {
    window.nodeTawk.parentNode.removeChild(window.nodeTawk);
    window.$_Tawk = null;
    window.$_Tawk_AccountKey = null;
    window.$_Tawk_Unstable = null;
    window.$_Tawk_WidgetId = null;
    window.$__TawkEngine = null;
    if (window.$__TawkSocket && window.$__TawkSocket.close) {
      window.$__TawkSocket.close();
    }
    window.$__TawkSocket = null;
  }
  let Tawk_API = Tawk_API || {},
    Tawk_LoadStart = new Date();
  var s1 = document.createElement("script"),
    s0 = document.getElementsByTagName("script")[0];
  s1.async = true;
  s1.src = CONSTS_CONFIG.liveHelp[country];
  s1.charset = "UTF-8";
  s1.setAttribute("crossorigin", "*");
  window.nodeTawk = s1;
  s0.parentNode.insertBefore(s1, s0);
  s1.onload = function() {
    console.log("js load success");
    callback();
  };
}

export function getCurrHost() {
  return window.location.protocol + "//" + window.location.host;
}

/**
 * icon
 * @param {*} money
 */
export function formateNumber(num, ispad = false) {
  if (num == null || num == undefined || num == "") {
    return "";
  }
  let pad = 2;
  if (ispad) {
    pad = 0;
  }
  if (isNaN(num)) return num;
  return (parseFloat(num).toFixed(pad) + "").replace(
    /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
    "$&,"
  );
}

//货币金额处理,千分位
export function thousandthPormat(num) {
  if (num != '') {
    return (num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
  } else {
    return num
  }
}
// 去除千分符
export function unThousandthPormat (num) {
  if (num && num != 'undefined' && num != 'null') {
    let numS = num;
    numS = numS.toString();
    numS = numS.replace(/,/gi, '');
    return numS;
  } else {
    return num;
  }
}


// 防抖函数
export function debounce(fn, delay = 500) {
  let timer = null;
  return function() {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, arguments);
      timer = null;
    }, delay);
  };
}

function fillZero(n){ 
  if (parseInt(n) < 10) return "0" + n;
  return n;
}

export function formatDate(datetime) {
    let date = new Date(datetime);
    let t = fillZero(date.getMonth() + 1) + "/" + fillZero(date.getDay()) + "/" + fillZero(date.getFullYear());
    t += " " + fillZero(date.getHours()) + ":" + fillZero(date.getMinutes()) + ":" + fillZero(date.getSeconds());
    return t;
}

export function setLocal(key, value) {
  window.localStorage.setItem(key, JSON.stringify(value));
}
export function getLocal(key) {
  let value = window.localStorage.getItem(key);
  return value == "undefined" || value == "null" ? "" : JSON.parse(value);
}
export function isBangbet() {
  let host = window.location.host;
  if(window.isBangbetCasinoDomain){
    return false
  }
  if (host.indexOf('xa.hw.luckygames') != -1) {
    return false;
  }
  if (host.indexOf('www.betsure') != -1 || host.indexOf('localhost') != -1 ||host.indexOf('www.bangbet') != -1 ||host.indexOf('hw.luckygames') != -1 || host.indexOf('192.168.') != -1) {
    return true;
  } else {
    return false;
  }
}

export function findClosestAmount(list, targetAmount) {
  if (targetAmount < list[0].amount) {
      return {};
  }
  // 遍历数组，找到最接近且不大于目标金额的对象
  for (let i = 0; i < list.length - 1; i++) {
      if (targetAmount >= list[i].amount && targetAmount < list[i + 1].amount) {
      return list[i]; // 返回当前的对象
      }
  }
  // 如果目标金额大于数组中的最大值，返回最大值
  return list[list.length - 1];
}



// WEBPACK FOOTER //
// ./src/utils/utils.js